import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    page: { type: Number, default: undefined },
    total: { type: Number, default: undefined },
    itemsPerPage: { type: Number, default: undefined },
  },
  data() {
    return {
      i18nEnabled: true,
    };
  },
  computed: {
    first(): number {
      return (this.page - 1) * this.itemsPerPage === 0 ? 1 : (this.page - 1) * this.itemsPerPage + 1;
    },
    second(): number {
      return this.page * this.itemsPerPage < this.total ? this.page * this.itemsPerPage : this.total;
    },
  },
});
